"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceWhitespace = exports.flexBuilder = exports.flexSmart = exports.flexTypeBuilder = void 0;

var _commonLib = require("@caps-mobile/common-lib");

var Types = _interopRequireWildcard(require("../interfaces/flex"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// deprecated functionality 
// should remove this before releasing Theming libraries
var flexTypeBuilder = function flexTypeBuilder(type) {
  if (!(0, _commonLib.nuon)(type)) return "";

  switch (type) {
    case Types.EFlexTypes.center:
      return flexBuilder({
        j: Types.EJustify.center,
        a: Types.EAlign.center
      });

    case Types.EFlexTypes["center-end"]:
      return flexBuilder({
        j: Types.EJustify.center,
        a: Types.EAlign["flex-end"]
      });

    case Types.EFlexTypes["center-start"]:
      return flexBuilder({
        j: Types.EJustify.center,
        a: Types.EAlign["flex-start"]
      });

    case Types.EFlexTypes["start-center"]:
      return flexBuilder({
        j: Types.EJustify["flex-start"],
        a: Types.EAlign.center
      });

    case Types.EFlexTypes["end-center"]:
      return flexBuilder({
        j: Types.EJustify["flex-end"],
        a: Types.EAlign.center
      });

    default:
      return "";
  }
};
/* 
    takes a string ( delimited by a single white space) and builds
    the flex styling corresponding to the given values representing: 
    justify-content, align-items respectively.
*/


exports.flexTypeBuilder = flexTypeBuilder;

var flexSmart = function flexSmart(type) {
  // abort if you are given null, undefined, or emptry string
  if (!(0, _commonLib.nuon)(type) || type === '') return "";
  /* 
      remove any superfluous whitespace (valid values cannot contain whitespace)
      this is basically syntactic sugar in case user accidentally added extra space
      when delimiting, but cannot protect against any other erroneous content
  */

  var modifiedType = reduceWhitespace(type); // check whether there is 1 or more values given

  var delimitIndex = modifiedType.indexOf(' ');
  var justify = "";
  var align = "";

  if (delimitIndex === -1) {
    // contains no ' ' delimiter, only justify given
    justify = type;
    align = null;
  } else {
    // delimiter exists both values given
    justify = type.substr(0, delimitIndex);
    align = type.substr(delimitIndex + 1, type.length - 1);
  }

  var j = Types.EJustify[justify] || null;
  var a = Types.EAlign[align] || null;
  return flexBuilder({
    j: j,
    a: a
  });
}; // helper function for other, more sophisticated flexBuilder functions


exports.flexSmart = flexSmart;

var flexBuilder = function flexBuilder() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Types.EFlexTypes.center;
  if (!config) return flexTypeBuilder(type);
  var j = config.justify || config.j || Types.IDEJustify;
  var a = config.align || config.a || Types.IDEAlign;
  var d = config.direction || config.d || Types.IDEDirection;
  return "\n        display: flex;\n        flex-direction: ".concat((0, _commonLib.nuon)(d) ? Types.EDirection[d] : Types.EDirection["row"], ";\n\n        justify-content: ").concat((0, _commonLib.nuon)(j) ? Types.EJustify[j] : Types.EJustify["flex-start"], ";\n\n        align-items: ").concat((0, _commonLib.nuon)(a) ? Types.EAlign[a] : Types.EAlign["stretch"], ";\n");
}; // helper function to reduce all instances of whitespace to a single space


exports.flexBuilder = flexBuilder;

var reduceWhitespace = function reduceWhitespace(rawString) {
  var modString = rawString;
  modString = modString.replace(/\s+/g, ' ');
  return modString;
};

exports.reduceWhitespace = reduceWhitespace;